/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StepDefinitions {
    ImportCVSFiles = 1,
    CountSec = 10,
    ShutdownButler = 11,
}
